export const STEPS = [
  { label: "export-insights-process-status-collecting-data", duration: 800 },
  {
    label: "export-insights-process-status-analyzing-reservations",
    duration: 1000,
  },
  { label: "export-insights-process-status-generating-graphs", duration: 700 },
  { label: "export-insights-process-status-creating-insights", duration: 900 },
  { label: "export-insights-process-status-finalizing-report", duration: 600 },
] as const;

export const REPORT_INCLUDES_ITEMS = [
  "export-insights-report-includes-item-1",
  "export-insights-report-includes-item-2",
  "export-insights-report-includes-item-3",
  "export-insights-report-includes-item-4",
  "export-insights-report-includes-item-5",
] as const;
